export interface AgendaAction {
  recId: number;
  scope: 'central' | 'tenant';
  actionCode: string | null;
  categoryId: number;
  actionName: string;
  actionDescription: string | null;
  dueSunday: boolean;
  dueMonday: boolean;
  dueTuesday: boolean;
  dueWednesday: boolean;
  dueThursday: boolean;
  dueFriday: boolean;
  beforeOpenDay: boolean;
  required4ValuationIsraeli: boolean;
  required4ValuationForeign: boolean;
  logicalOrder: number | null;
  ask4Comment: boolean;
  rowColor: number | null;
  isActive: boolean;
}

export interface AgendaActionBatchRequest {
  added: AgendaAction[];
  modified: AgendaAction[];
  deleted: number[];
}

export interface AgendaCategory {
  categoryId: number;
  categoryName: string;
  isActive: boolean;
}

export interface AgendaCategoryBatchRequest {
  added: AgendaCategory[];
  modified: AgendaCategory[];
  deleted: number[];
}

export interface ValuationType {
  valuationTypeId: number;
  valuationTypeCode: string;
  valuationTypeName: string;
  isActive: boolean;
}

export interface ValuationTypeBatchRequest {
  added: ValuationType[];
  modified: ValuationType[];
  deleted: number[];
}

export const AGENDA_SCOPES = ['central', 'tenant'] as const;
